import { SelectedPortOutput } from './selected-port-output.model';


export class DeviceWithOutStatusOutputData implements IDeviceWithOutStatusOutputData {
    /** The auto-generated id of the device master */
    device_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The auto-generated id of the user master */
    user_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The auto-generated id of the sim card master */
    sim_card_details_id!: number;
    /** The IMEI number with 500 character */
    imei_number!: string;
    /** The auto-generated id of the device model master */
    device_model_id!: number;
    /** The auto-generated id of the device brand master */
    device_brand_id!: number;
    /** The auto-generated id of the time zone master */
    time_zone_id!: number;
    /** The expiry date should be with 10 character */
    installation_date!: string;
    /** The ignore heart beat data 0 for unselected, 1 for selected */
    ignore_heart_beat_data!: number;
    /** The ign based on speed 0 for unselected, 1 for selected */
    ign_based_on_speed!: number;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicle_license!: number;
    /** The expiry date should be with 10 character */
    expiry_date!: string;
    /** The notify 0 for unselected, 1 for selected */
    notify!: number;
    /** The show expiryMessage days */
    show_expiry_message_days!: number;
    /** The fuel consumption based on  should be  "Distance" or "Duration" */
    fuel_consumption_based_on!: string;
    /** The fuel consumption with 200 character limit */
    fuel_consumption!: string;
    selected_port_specification!: SelectedPortOutput[];
    status!: number;

    constructor(data?: IDeviceWithOutStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_id = _data["device_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.user_id = _data["user_id"];
            this.company_details_id = _data["company_details_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.sim_card_details_id = _data["sim_card_details_id"];
            this.imei_number = _data["imei_number"];
            this.device_model_id = _data["device_model_id"];
            this.device_brand_id = _data["device_brand_id"];
            this.time_zone_id = _data["time_zone_id"];
            this.installation_date = _data["installation_date"];
            this.ignore_heart_beat_data = _data["ignore_heart_beat_data"];
            this.ign_based_on_speed = _data["ign_based_on_speed"];
            this.vehicle_license = _data["vehicle_license"];
            this.expiry_date = _data["expiry_date"];
            this.notify = _data["notify"];
            this.show_expiry_message_days = _data["show_expiry_message_days"];
            this.fuel_consumption_based_on = _data["fuel_consumption_based_on"];
            this.fuel_consumption = _data["fuel_consumption"];
            if (Array.isArray(_data["selected_port_specification"])) {
                this.selected_port_specification = [] as any;
                for (let item of _data["selected_port_specification"])
                    this.selected_port_specification!.push(SelectedPortOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceWithOutStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceWithOutStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_id"] = this.device_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["user_id"] = this.user_id;
        data["company_details_id"] = this.company_details_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["sim_card_details_id"] = this.sim_card_details_id;
        data["imei_number"] = this.imei_number;
        data["device_model_id"] = this.device_model_id;
        data["device_brand_id"] = this.device_brand_id;
        data["time_zone_id"] = this.time_zone_id;
        data["installation_date"] = this.installation_date;
        data["ignore_heart_beat_data"] = this.ignore_heart_beat_data;
        data["ign_based_on_speed"] = this.ign_based_on_speed;
        data["vehicle_license"] = this.vehicle_license;
        data["expiry_date"] = this.expiry_date;
        data["notify"] = this.notify;
        data["show_expiry_message_days"] = this.show_expiry_message_days;
        data["fuel_consumption_based_on"] = this.fuel_consumption_based_on;
        data["fuel_consumption"] = this.fuel_consumption;
        if (Array.isArray(this.selected_port_specification)) {
            data["selected_port_specification"] = [];
            for (let item of this.selected_port_specification)
                data["selected_port_specification"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceWithOutStatusOutputData {
    /** The auto-generated id of the device master */
    device_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The auto-generated id of the user master */
    user_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The auto-generated id of the sim card master */
    sim_card_details_id: number;
    /** The IMEI number with 500 character */
    imei_number: string;
    /** The auto-generated id of the device model master */
    device_model_id: number;
    /** The auto-generated id of the device brand master */
    device_brand_id: number;
    /** The auto-generated id of the time zone master */
    time_zone_id: number;
    /** The expiry date should be with 10 character */
    installation_date: string;
    /** The ignore heart beat data 0 for unselected, 1 for selected */
    ignore_heart_beat_data: number;
    /** The ign based on speed 0 for unselected, 1 for selected */
    ign_based_on_speed: number;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicle_license: number;
    /** The expiry date should be with 10 character */
    expiry_date: string;
    /** The notify 0 for unselected, 1 for selected */
    notify: number;
    /** The show expiryMessage days */
    show_expiry_message_days: number;
    /** The fuel consumption based on  should be  "Distance" or "Duration" */
    fuel_consumption_based_on: string;
    /** The fuel consumption with 200 character limit */
    fuel_consumption: string;
    selected_port_specification: SelectedPortOutput[];
    status: number;
}

